import { put, call, takeEvery } from 'redux-saga/effects';
import { replace } from 'connected-react-router';
import {
  ANNOUNCEMENTS_REQUEST,
  ANNOUNCEMENT_REQUEST,
  CREATE_ANNOUNCEMENT_REQUEST,
  UPDATE_ANNOUNCEMENT_REQUEST,
  DELETE_ANNOUNCEMENT_REQUEST,
} from './actionTypes';
import {
  announcementsSuccess,
  announcementsFailure,
  announcementSuccess,
  announcementFailure,
  createAnnouncementSuccess,
  createAnnouncementFailure,
  updateAnnouncementSuccess,
  updateAnnouncementFailure,
  deleteAnnouncementSuccess,
  deleteAnnouncementFailure,
} from './actions';
import AnnouncementService from '../../services/AnnouncementService';

export function* getAnnouncementsTask() {
  try {
    const list = yield call(AnnouncementService.getAnnouncements);
    yield put(announcementsSuccess(list));
  } catch (error) {
    yield put(announcementsFailure(error));
  }
}

export function* getAnnouncementTask(action) {
  try {
    const announcementId = action.payload;
    const announcement = yield call(
      AnnouncementService.getAnnouncement,
      announcementId,
    );
    yield put(announcementSuccess(announcement));
  } catch (error) {
    yield put(announcementFailure(error));
  }
}

export function* createAnnouncementTask(action) {
  try {
    const params = action.payload;
    const announcement = yield call(
      AnnouncementService.createAnnouncement,
      params,
    );
    yield put(createAnnouncementSuccess(announcement));
    yield put(replace('/announcements'));
  } catch (error) {
    yield put(createAnnouncementFailure(error));
  }
}

export function* updateAnnouncementTask(action) {
  try {
    const params = action.payload;
    const announcement = yield call(
      AnnouncementService.updateAnnouncement,
      params,
    );
    yield put(updateAnnouncementSuccess(announcement));
    yield put(replace('/announcements'));
  } catch (error) {
    yield put(updateAnnouncementFailure(error));
  }
}

export function* deleteAnnouncementTask(action) {
  try {
    const announcementId = action.payload;
    yield call(AnnouncementService.deleteAnnouncement, announcementId);
    yield put(deleteAnnouncementSuccess(announcementId));
  } catch (error) {
    yield put(deleteAnnouncementFailure(error));
  }
}

export function* announcementsSaga() {
  yield takeEvery(ANNOUNCEMENTS_REQUEST, getAnnouncementsTask);
  yield takeEvery(ANNOUNCEMENT_REQUEST, getAnnouncementTask);
  yield takeEvery(CREATE_ANNOUNCEMENT_REQUEST, createAnnouncementTask);
  yield takeEvery(UPDATE_ANNOUNCEMENT_REQUEST, updateAnnouncementTask);
  yield takeEvery(DELETE_ANNOUNCEMENT_REQUEST, deleteAnnouncementTask);
}
